import React from "react";
import Form from 'react-bootstrap/Form';
import { Badge, Table } from 'react-bootstrap';

export default function SetupDepartmentTable(props) {

    const renderBadge = (status) => {
        switch(status) {
            case 'Submitted':
                return <Badge bg="primary" text="light">Submitted</Badge>
            case 'Saved':
                return <Badge bg="warning" text="light">Saved</Badge>
            default:
                return <></>
        }
    }

    // 
    // If an assessment is saved OR there are no active learning outcomes found,
    // then disallow changing of the mapping
    //
    const isDisabled = (programId, learningOutcomes) => {
        let result = false
        if (learningOutcomes === undefined || learningOutcomes.length === 0) {
            result = true
            return result
        }
        Object.keys(props.programAssessmentsCreated).forEach((pid) => {
            if (parseInt(pid) === programId) {
                result = true
                return
            }
        })
        return result
    }

    // Prep our dictionary to store status of program setup mappings
    let mappedPrograms = {}
    props.departmentPrograms.forEach((program) => {
        mappedPrograms[program.programId] = ''
    })

    // Update our dictionary with the status based on the submittedBy property
    let savedMappings = {}
    if (props.setup && props.setup.mappings) {
        savedMappings = props.setup.mappings
        props.departmentPrograms.forEach((program) => {
            if (program.programId in savedMappings) {
                let submittedFound = savedMappings[program.programId].find((m) => m.submittedBy !== undefined && m.submittedBy !== '')
                if (submittedFound) {
                    mappedPrograms[program.programId] = 'Submitted'
                } else {
                    mappedPrograms[program.programId] = 'Saved'
                }
            }
        })
    }
    
    let programLearningOutcomes = {}
    if (props.departmentLearningOutcomes && (props.departmentId in props.departmentLearningOutcomes)) {
        programLearningOutcomes = props.departmentLearningOutcomes[props.departmentId]?.learningOutcomes
    }  
    
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <th>Programs</th>
                        <th></th>
                        <th>Programs to set up</th>
                    </tr>
                </thead>
                <tbody>
                    { props.departmentPrograms &&
                        props.departmentPrograms.map((program,key) =>
                            <tr key={key}>
                                <td>
                                    {program.label}
                                </td>
                                <td>
                                    { renderBadge(mappedPrograms[program.programId]) }
                                </td>
                                <td className="mx-auto text-left">
                                    <Form.Select
                                        onChange={props.onThemeChanged}
                                        name={program.programId}
                                        aria-label="Will the program mapping be setup?"
                                        defaultValue={program.isActive}
                                        disabled={isDisabled(program.programId, programLearningOutcomes[program.programId])}
                                        >
                                        <option value="no">No</option>
                                        <option value="yes">Yes</option>
                                    </Form.Select>
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </div>
    )
}